import Loading from "@components/common/loading/Loading";
import { useTransition, animated } from "@react-spring/web";
import { useLiveQuery } from "dexie-react-hooks";
import moment from "moment";
import React, { useEffect, useState } from "react";

import NoteItem from "./NoteItem";
import NapTime from "../../../assets/imgs/otto-scribbles-sleep.svg";
import { db } from "../../../db";
import LoadMore from "../../common/inbox/LoadMore";
import UnsyncedRecordingsList from "../../inbox/UnsyncedRecordingsList";

function EmptyState() {
  return (
    <div className="p-10 h-full flex">
      <div className="flex flex-col self-center justify-self-center space-y-5">
        <img
          className="flex self-center"
          width="250px"
          src={NapTime}
        />

        <h4 className="text-center text-sm text-secondary">
          Take a paws...
        </h4>
        <h5
          className="text-center text-xs text-placeholder"
          data-testid="empty-inbox-message"
        >
          There are no new notes for you to catch up on for now. Go on
          and enjoy the rest of your day! <br /> (and let Otto and
          Scribbles catch some Z&apos;s)
        </h5>
      </div>
    </div>
  );
}

function NoteList(props) {
  const {
    items,
    incrementOffset,
    loadingMore,
    totalNotes,
    handleActionWithPrevention,
    loading,
    dataTestId,
  } = props;

  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 5000);
    return () => clearInterval(id);
  }, []);

  const unsyncedCount =
    useLiveQuery(() => {
      const threshold = moment().subtract(15, "seconds").format();
      return db.unsyncedRecordings
        .filter((r) => !r.is_synced && r.saved_date < threshold)
        .count();
    }, [tick]) ?? 0;

  const fadeAnim = useTransition(loading, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return (
    <>
      {fadeAnim((styles, item) =>
        !item ? (
          <div
            className="relative h-full w-full"
            data-testid={dataTestId}
          >
            <div className="z-10 bg-linear-to-t from-primary via-primary absolute bottom-0 w-full flex justify-center pt-10 px-5 pointer-events-none"></div>
            {!items?.length && unsyncedCount === 0 ? (
              <div className="w-[85%] h-[85%] mx-auto">
                <EmptyState />
              </div>
            ) : (
              <div className="max-h-[400px] overflow-y-auto">
                <UnsyncedRecordingsList />
                <div>
                  {items.map((note) => (
                    <div
                      key={note.uuid}
                      className="my-md mx-sm"
                      data-testid="note-item-individual-container"
                    >
                      <NoteItem
                        handleActionWithPrevention={
                          handleActionWithPrevention
                        }
                        dashboard={true}
                        note={note}
                        {...props}
                        dataTestIdUuid={`note-item-${note.uuid}`}
                        dataTestIdTemplate="note-template-type"
                        dataTestIdNoteTitle={`note-item-title-${note.title}`}
                      />
                    </div>
                  ))}

                  {totalNotes > items.length && (
                    <LoadMore
                      incrementOffset={incrementOffset}
                      loadingMore={loadingMore}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        ) : (
          <animated.div
            style={styles}
            className="absolute flex flex-col h-full min-h-[400px] min-w-full place-content-center z-10 top-0"
          >
            <Loading shouldShow={true} />
            <h4 className="mt-10 text-center text-base text-secondary">
              Loading...
            </h4>
          </animated.div>
        ),
      )}
    </>
  );
}

export default NoteList;
